import { GameObject } from "../core/GameObject";
import { ObjectPool } from "./ObjectPool";

export abstract class PoolGameObject extends GameObject {
	objectPool: ObjectPool<PoolGameObject>;
	abstract poolDestroy(): void;
	abstract poolSetup(...args: any[]): void;

	private free(): void {
		this.emit(Phaser.GameObjects.Events.DESTROY);
		this.objectPool.free(this);
	}

	destroy(): void {
		this.free();
	}

	destroyForReal(): void {
		super.destroy();
	}
}